let accountId: string | null = null;
const listeners = new Set<() => void>();

export function getMomentAccountId(): string | null { return accountId; }

export function setMomentAccountId(value: string | null): void {
  if (accountId === value) return;
  accountId = value;
  for (const listener of listeners) listener();
}

export function subscribeMomentAccount(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
